import React from "react"

const ComingSoonOverlay = ({
  children,
  label = "Coming Soon",
  className = "",
}) => (
  <div className={`coming-soon-overlay${className ? ` ${className}` : ""}`}>
    <div className="coming-soon-overlay__content" aria-hidden="true">
      {children}
    </div>
    <div className="coming-soon-overlay__veil" role="status">
      <span className="coming-soon-overlay__label">{label}</span>
    </div>
  </div>
)

export default ComingSoonOverlay
